import React, {useContext, useState} from 'react';
import {ForgotPasswordRequest} from "../../app/models/signin/ForgotPasswordRequest";
import {Store} from "../../app/stores/store-root";
import MessageModal from "../../app/common/message-modal";
import * as yup from "yup";
import {Formik} from "formik";
import {EuiFieldText, EuiFormRow} from "@elastic/eui";
import {ForgotPasswordSubmitRequest} from "../../app/models/signin/ForgotPasswordSubmitRequest";
import { useHistory } from 'react-router-dom';

const ForgotPasswordSubmitForm = () => {
    const history = useHistory();
    const [request, setRequest] = useState<ForgotPasswordSubmitRequest>(new ForgotPasswordSubmitRequest('','',''));
    const store = useContext(Store);
    const onSubmit = (values: ForgotPasswordSubmitRequest) => {
        store.Users.forgotPasswordSubmit(values).then(()=>{
            store.Modal.openModal(<MessageModal message={'Password reset sent successfully. Please try to sign in' +
            ' again using your new password'} success={true}/>)
            history.push('/signin')
        }).catch((e)=>{
            store.Modal.openModal(<MessageModal message={`Unable to submit password reset request. The following` +
            ` error encountered : ${e}  `} success={false}/>)
        });
    }

    const formSchema = yup.object().shape({
        username: yup.string().required('username is required'),
        newPassword : yup.string().required('New Password is required'),
        code : yup.string().required('Code is required')
    })
    return (
        <Formik initialValues={request} onSubmit={onSubmit} enableReinitialize={true} validationSchema={formSchema}>
            {(formik) => (
                <form onSubmit={formik.handleSubmit}>
                    <div
                        className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
                        <div className="mx-auto w-full max-w-sm lg:w-96">
                            <div>
                                <h2 className="mt-6 text-3xl leading-9 font-extrabold text-gray-900">
                                    Reset your account password
                                </h2>
                                <h2 className="mt-6 text-xl leading-9 font-extrabold text-gray-900">
                                    Confirm you user name, code, and new password.
                                </h2>
                            </div>
                            <div className="mt-8">
                                <div className="mt-6">
                                    <div className="space-y-6">
                                        <div>
                                            <label
                                                htmlFor="email"
                                                className="block text-sm font-medium leading-5 text-gray-700"
                                            >
                                                User name
                                            </label>
                                            <div className="mt-1 rounded-md shadow-sm">
                                                <EuiFormRow
                                                    isInvalid={((formik.getFieldMeta('username').error) && (formik.getFieldMeta('username').touched)) ? true : false}
                                                    error={formik.getFieldMeta('username').error}>
                                                    <EuiFieldText
                                                        {...formik.getFieldProps("username")}
                                                        isInvalid={((formik.getFieldMeta('username').error) && (formik.getFieldMeta('username').touched)) ? true : false}
                                                    />
                                                </EuiFormRow>
                                            </div>
                                        </div>
                                        <div>
                                            <label
                                                htmlFor="email"
                                                className="block text-sm font-medium leading-5 text-gray-700"
                                            >
                                                Code
                                            </label>
                                            <div className="mt-1 rounded-md shadow-sm">
                                                <EuiFormRow
                                                    isInvalid={((formik.getFieldMeta('code').error) && (formik.getFieldMeta('code').touched)) ? true : false}
                                                    error={formik.getFieldMeta('code    ').error}>
                                                    <EuiFieldText
                                                        {...formik.getFieldProps("code")}
                                                        isInvalid={((formik.getFieldMeta('code').error) && (formik.getFieldMeta('code').touched)) ? true : false}
                                                    />
                                                </EuiFormRow>
                                            </div>
                                        </div>
                                        <div>
                                            <label
                                                htmlFor="email"
                                                className="block text-sm font-medium leading-5 text-gray-700"
                                            >
                                                New password
                                            </label>
                                            <div className="mt-1 rounded-md shadow-sm">
                                                <EuiFormRow
                                                    isInvalid={((formik.getFieldMeta('newPassword').error) && (formik.getFieldMeta('newPassword').touched)) ? true : false}
                                                    error={formik.getFieldMeta('newPassword').error}>
                                                    <EuiFieldText
                                                        {...formik.getFieldProps("newPassword")}
                                                        isInvalid={((formik.getFieldMeta('newPassword').error) && (formik.getFieldMeta('newPassword').touched)) ? true : false}
                                                    />
                                                </EuiFormRow>
                                            </div>
                                        </div>

                                        <div className='pt-6'>
                      <span className="block w-full rounded-md shadow-sm">
                        <button
                            type="submit"
                            className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-600 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700 transition duration-150 ease-in-out font-bold"
                        >
                          Reset My Password
                        </button>
                      </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}
        </Formik>
    );
};

export default ForgotPasswordSubmitForm;